import { render, staticRenderFns } from "./ReportLoader.vue?vue&type=template&id=0a8a89f4&scoped=true"
import script from "./ReportLoader.vue?vue&type=script&lang=ts"
export * from "./ReportLoader.vue?vue&type=script&lang=ts"
import style0 from "./ReportLoader.vue?vue&type=style&index=0&id=0a8a89f4&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8a89f4",
  null
  
)

export default component.exports